import { PhosphorFileX, PhosphorIconForFileUpload } from "components/Atoms/PhosphorIcon";
import classNames from "classnames";
import React from "react";
import Dropzone, { Accept, DropEvent, FileRejection } from "react-dropzone";
import { formatBytes } from "utilities/fileutils";

interface FileDropzoneProps {
  error?: boolean;
  iconType: "image" | "file" | "docx" | "pdf";
  accept?: Accept;
  uploadLabel?: string;
  maxFiles?: number;
  maxSizeBytes: number;
  onDrop: (files: FileList | File[]) => void;
  onDropReject: (fileRejections: FileRejection[], event: DropEvent) => void;
}

export const FileDropzone = (props: FileDropzoneProps) => {
  const {
    iconType,
    accept,
    maxFiles = 0, // Unlimited number of files
    uploadLabel = RESX.Buttons.Upload,
    maxSizeBytes,
  } = props;

  return <Dropzone
    accept={accept}
    maxFiles={maxFiles}
    multiple={maxFiles !== 1}
    maxSize={maxSizeBytes}
    onDrop={props.onDrop}
    onDropRejected={props.onDropReject}
  >
    {({ getRootProps, getInputProps, isDragActive, isDragReject }) => {
      return <div
        style={{ width: "100%" }}
        {...getRootProps()}
        className={classNames("flex align-center justify-center dropzone padding-larger", {
          "dropzoneactive": isDragActive,
          "dropzoneerror": props.error,
        })}
      >
        <input {...getInputProps()} />
        <div className="flex-column align-center justify-center" style={{ minHeight: 68 }}>
          {!isDragReject && <>
            <div className="padding-small">
              <PhosphorIconForFileUpload type={iconType} error={props.error} />
            </div>
            <div className="margin-bottom-small">
              <span style={{ color: "var(--primary-color)" }}>
                {uploadLabel}
              </span>
              &nbsp;{RESX.File.orDragAndDrop}
            </div>
            <div className="text-sublabel">({RESX.File.MaxFileSize}: {formatBytes(maxSizeBytes)})</div>
          </>}
          {isDragReject && <>
            <div className="padding-small">
              <PhosphorFileX iconSize="large" />
            </div>
            <div className="margin-bottom-small">
              {RESX.File["Invalid file"]}
            </div>
          </>}
        </div>
      </div>;
    }}
  </Dropzone>
}